import { getData, postData } from "../global/Globalapi"

export const GetOrderData=async()=>{
  try {
    const res= await getData('/admin/orders');
    if(res){
        console.log("OrderData: ", res);
        return res;
    }
  } catch (error) {
    console.log("Error fetching OrderData: ", error);
  }
}

export const OrderStatus=async(id,status)=>{
  try {
    const res=await postData('/admin/orders/status',{id,status});
    if(res){
      console.log("Order status updated successfully: ", res);
      return res;
    }
  } catch (error) {
    console.log("Error updating order status: ", error);
  }
}